export interface MasterDataVersionLike {
  id?: number | null;
  versionNumber?: number | null;
  manualRevision?: string | null;
}

/**
 * Version 0 is reserved for bundled/local bootstrap data. Older v0.148.0
 * clients persisted that same bootstrap state with `versionNumber = null`, so
 * `null` + no server id is deliberately treated as bootstrap as well.
 */
export function isLocalBootstrapVersion(version: MasterDataVersionLike | null | undefined): boolean {
  if (!version) return false;
  return (version.id ?? null) === null && (version.versionNumber == null || version.versionNumber <= 0);
}

export function hasMasterDataUpdate(
  server: MasterDataVersionLike | null | undefined,
  local: MasterDataVersionLike | null | undefined,
): boolean {
  if (!server || !local || isLocalBootstrapVersion(local)) return false;
  const serverVersion = server.versionNumber ?? null;
  const localVersion = local.versionNumber ?? null;
  const newerVersion = serverVersion !== null && localVersion !== null && serverVersion > localVersion;
  const revisionChanged = (server.manualRevision ?? null) !== (local.manualRevision ?? null);
  return newerVersion || revisionChanged;
}

export function isMasterDataCurrent(
  server: MasterDataVersionLike | null | undefined,
  local: MasterDataVersionLike | null | undefined,
): boolean {
  if (!server || !local || isLocalBootstrapVersion(local)) return false;
  return (server.versionNumber ?? null) === (local.versionNumber ?? null)
    && (server.manualRevision ?? null) === (local.manualRevision ?? null);
}
